import { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Input, InputNumber, MainModal, message, Modal, Pie, PieChart, ProTableOt, Row, setParamsFilter, Tabs, useProTableOt } from './../../ui/ot'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePlan } from './../controllers/plan_controller'
import { usePlanRecord } from './../controllers/plan_record_controller'
import { usePosition } from './../controllers/position_controller'
import { createContext } from 'react';
import { useContext } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';

const LanguageContext = createContext(null);

const PlanManagement = ({
    keyPrefix = 'inventory_check.plan'
}) => {
    const { t } = useTranslation("translation", {
        keyPrefix
    });

    const navigate = useNavigate();
    const actionRef = useRef(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postPlanData([values])
        }
        else if (axiosMode === "patch") {
            patchPlanData([values])
        }
    }

    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log({
                selected,
                selectedRows,
                changeRows,
            });
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.plan_id);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.plan_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record.plan_id);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record.plan_id
                );
                selectRow = selectRow.filter(
                    (row) => row.plan_id !== record.plan_id
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {

        setAxiosMode("patch")
        setModalOpen(true)

        form.resetFields()
        form.setFieldsValue({
            ...record,
        })
    }
    const handleOnDeleteRow = (record) => {
        Modal.confirm({
            content: '確定要刪除嗎？',
            onOk: () => {
                deletePlanData([{ plan_id: record.plan_id }])
            },
            okText: '確定',
            cancelText: '取消'
        })
    }
    const onFinish = ({ axiosMode, status, values }) => {
        switch (axiosMode) {
            case "get":

                break;
            case 'post':
                if (status === 'success') {
                    message.success("新增成功")
                    actionRef.current.reloadAndRest()
                } else {
                    message.error("新增失敗")
                }
                break;
            case 'patch':
                if (status === 'success') {
                    message.success("新增成功")
                    actionRef.current.reloadAndRest()
                } else {
                    message.error("新增失敗")
                }
                break;
            case 'delete':
                if (status === 'success') {
                    message.success("刪除成功")
                    actionRef.current.reloadAndRest()
                } else {
                    message.error("刪除失敗")
                }
                break;
            default:
                break;
        }
        setModalLoading(false)
        setModalOpen(false)
    }
    const onBefore = () => {
    }

    const columns = [
        {
            key: "code",
            title: t('code'),
            dataIndex: "code",
        },
        {
            key: "duration",
            title: t('duration'),
            dataIndex: "duration"
        },
        {
            key: "plan_record_data",
            title: t("plan_record_data"),
            render: (text, record) => (
                <>
                    <div className="lowercase">
                        <Button
                            className=" text-blue-600 p-2"
                            variant="ghost"
                            onClick={() => {
                                Modal.info({
                                    title: t("plan_record_data"),
                                    content: (
                                        <>
                                            {record?.plan_record_data?.map((item) => (
                                                <>
                                                    <Row gutter={[24, 24]}>
                                                        <Col>
                                                            {`${t('number')}:${item?.number}`}
                                                        </Col>
                                                        <Col>
                                                            {`${t('check_number')}:${item?.check_number}`}
                                                        </Col>
                                                        <Col>
                                                            {`${t('reason')}:${item?.reason || ''}`}
                                                        </Col>
                                                    </Row>
                                                </>
                                            ))}
                                        </>
                                    ),
                                    okText: t("close"),
                                });
                            }}
                        >
                            {t("plan_record_data")}
                        </Button>
                    </div>
                </>
            ),
        },
        {
            key: "Action",
            title: t('action'),
            render: (text, record) => <div className="lowercase w-48">
                <PlanRecordModal record={record} />
                /
                <Button className=' text-blue-600 p-2' variant="ghost" onClick={() => { handleEditRow(record) }}>編輯</Button>
                /
                <Button className=' text-red-600 p-2' variant="ghost" onClick={() => handleOnDeleteRow(record)}>{t('delete')}</Button>
            </div>,
        },

    ]

    const {
        PlanData,
        getPlanData,
        postPlanData,
        patchPlanData,
        deletePlanData
    } = usePlan({
        onFinish,
        onBefore,
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        checkAll();
    }, []);
    return <>
        <LanguageContext.Provider value={keyPrefix}>
            <MainModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}

                onFinish={onFormFinish}
                formElement={<PlanForm />}
            />
            <div className="flex items-center py-4">

                <Button
                    onClick={handleAddRow}
                >
                    <svg className="mr-3" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-plus" viewBox="0 0 16 16">
                        <path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5" />
                        <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                    </svg>
                    {t('post_plan')}
                </Button>
            </div>
            <ProTableOt
                actionRef={actionRef}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={"plan_id"}
                request={async (params = {}, sort, filter) => {
                    // setAxiosMode("get")
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    // setPageSize(params?.pageSize ?? 20)

                    return getPlanData({
                        ...newParams,
                    });
                }}
                toolBarRender={() => {
                    return [
                        <Button
                            type={'default'}
                            style={{
                                color: 'green'
                            }}
                            onClick={() => {
                                actionRef.current.reload();
                            }}
                        >
                            {t('import')}
                        </Button>,
                        <Button
                            type={'default'}
                            style={{
                                color: 'darkgreen'
                            }}
                            onClick={() => {
                                actionRef.current.reload();
                            }}
                        >
                            {t('export')}
                        </Button>,
                        <Button
                            type={'danger'}
                            onClick={() => {
                                actionRef.current.reload();
                            }}
                        >
                            {t('delete')}
                        </Button>,
                    ];
                }}
                rowSelection={{
                    type: "checkbox",
                    selectedRowKeys: selectedRowKeys,
                    ...rowSelection,
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={true}
            />
        </LanguageContext.Provider>
    </>
}

const PlanForm = ({
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    keyPrefix = 'inventory_check.plan'
}) => {
    const [form] = Form.useForm();
    const keyPrefix_ = useContext(LanguageContext);
    const { t } = useTranslation("translation", {
        keyPrefix: keyPrefix_ || keyPrefix,
    });
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf('day');
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour))
            }
            else {
                return range(0, 24).splice(0, 0)
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm")
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            let currentHour = dayjs(current).format('HH')
            console.log({ minutes })
            if (todayDate === currentDate && currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes) + 5)
            }
            else {
                return range(0, 0)
            }
        },
        disabledSeconds: () => {
            return range(0, 0)
        },
    });

    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"plan_id"}
                            >
                                <div />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={t('code')}
                                name={"code"}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={t('duration')}
                                name={"duration"}
                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>
                    </Row >
                </Form>
            </Col>
        </Row >
    </>
}
export default PlanManagement


const PlanRecordModal = ({
    keyPrefix = "inventory_check.plan",
    record
}) => {
    const keyPrefix_ = useContext(LanguageContext);
    const { t } = useTranslation("translation", {
        keyPrefix: keyPrefix_ || keyPrefix,
    });

    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get");

    const onFormFinish = (values) => {
        console.log(values);
        postPlanRecordData([values])
    };

    const handleAddRow = () => {
        setAxiosMode("post");
        setModalOpen(true);
        form.resetFields();
    };
    const handleEditRow = (record) => {
        setAxiosMode("patch");
        setModalOpen(true);

        form.resetFields();
        form.setFieldsValue({
            ...record,
        });
    };
    const handleOnDeleteRow = (record) => {
        Modal.confirm({
            content: "確定要刪除嗎？",
            onOk: () => {
                // deleteItem([{ item_id: record.item_id }])
            },
            okText: "確定",
            cancelText: "取消",
        });
    };
    const { postPlanRecordData } = usePlanRecord({
        onFinish: ({ axiosMode, status }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success('送出成功')
                    setModalOpen(false)
                }
            } else {
                if (axiosMode === "post") {
                    message.error('操作失敗，請稍後再試')
                }
            }
        }
    })
    return <>
        <Button
            className="text-green-600 p-2"
            variant="ghost"
            onClick={() => handleEditRow(record)}
        >
            {t("post_plan_record")}
        </Button>
        <MainModal
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}
            propsForm={form}
            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}
            onFinish={onFormFinish}
            formElement={<VisualizationPlanRecordForm />}
            width={1000}
            title={t('post_plan_record')}
        />
    </>
}
const PlanRecordForm = ({
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    keyPrefix = "inventory_check.plan"
}) => {
    const keyPrefix_ = useContext(LanguageContext);
    const { t } = useTranslation("translation", {
        keyPrefix: keyPrefix_ || keyPrefix,
    });
    const [form_] = Form.useForm();
    const form = propsForm || form_

    const setFormValuesOtherThings = (formValues, name) => {
        //做一些你可能會用到其他component的資料整理
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        // setFormValuesOtherThings(formValues, name);
    };
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf("day");
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH");
            let todayDate = dayjs().format("YYYY-MM-DD");
            let currentDate = dayjs(current).format("YYYY-MM-DD");
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour));
            } else {
                return range(0, 24).splice(0, 0);
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm");
            let hour = dayjs().format("HH");
            let todayDate = dayjs().format("YYYY-MM-DD");
            let currentDate = dayjs(current).format("YYYY-MM-DD");
            let currentHour = dayjs(current).format("HH");
            console.log({ minutes });
            if (todayDate === currentDate && currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes) + 5);
            } else {
                return range(0, 0);
            }
        },
        disabledSeconds: () => {
            return range(0, 0);
        },
    });

    useEffect(() => {
        setDataInitialization();
    }, []);
    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);

    const onFinish = () => {
        let values = form.getFieldsValue();
        // if (ship_out_id) {
        //   patchShipOut([{
        //     ...values,
        //     estimate_time,
        //   }]);
        // } else {
        onFormFinish(values);
        // }
    };

    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                    initialValues={{
                        total_number: 0,
                        total_amount: 0
                    }}
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item hidden={true} name={"plan_id"}>
                                <div />
                            </Form.Item>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <Form.Item
                                label={t('x')}
                                name={"x"}
                            >
                                <InputNumber
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <Form.Item
                                label={t('y')}
                                name={"y"}
                            >
                                <InputNumber
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <Form.Item
                                label={t('z')}
                                name={"z"}
                            >
                                <InputNumber
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                label={t('number')}
                                name={"number"}
                            >
                                <InputNumber
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                label={t('check_number')}
                                name={"check_number"}
                            >
                                <InputNumber
                                />
                            </Form.Item>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Form.Item
                                label={t('reason')}
                                name={"reason"}
                            >
                                <Input
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
const VisualizationPlanRecordForm = ({
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    keyPrefix = "inventory_check.plan"
}) => {
    const keyPrefix_ = useContext(LanguageContext);
    const { t } = useTranslation("translation", {
        keyPrefix: keyPrefix_ || keyPrefix,
    });
    const [form] = Form.useForm()
    const [modeActiveKey, setModeActiveKey] = useState(t('visualization'))
    const [activeKey, setActiveKey] = useState()
    const [data, setData] = useState([]);

    const {
        PositionData,
        getPositionData
    } = usePosition({});

    useEffect(() => {
        getPositionData()
    }, [])

    useEffect(() => {
        setTimeout(() => {
            setData([
                { type: '分类一', value: 27 },
                { type: '分类二', value: 25 },
                { type: '分类三', value: 18 },
                { type: '分类四', value: 15 },
                { type: '分类五', value: 10 },
                { type: '其他', value: 5 },
            ]);
        }, 1000);
    }, []);


    useEffect(() => {
        if (activeKey !== undefined)
            form.setFieldsValue(PositionData?.find(item => item?.position_id === activeKey))
    }, [activeKey])
    const row = Form.useWatch('row', form) ?? 0;
    const column = Form.useWatch('column', form) ?? 0;
    const height = Form.useWatch('height', form) ?? 0;
    return <>
        <Row>
            <Col>
                <Tabs
                    activeKey={modeActiveKey}
                    onChange={setModeActiveKey}
                    items={[
                        {
                            key: t('visualization'),
                            tab: t('visualization')
                        },
                        {
                            key: t('list'),
                            tab: t('list')
                        },
                    ]}
                />
            </Col>
        </Row>
        {modeActiveKey === t('visualization') && <>
            <Tabs
                activeKey={activeKey}
                onChange={setActiveKey}
                items={PositionData.map(record => (
                    {
                        key:
                            record?.position_id,
                        tab:
                            (
                                record?.name_language_data || []
                            )?.find(
                                (tmp) =>
                                    tmp?.language_culture_code ===
                                    "zh-tw"
                            )?.language_culture_value || "-",
                    }
                ))}
            />
            <Row>
                <Col span={12}>
                    <PieChart
                        {...{
                            data,
                            angleField: 'value',
                            colorField: 'type',
                            label: {
                                text: 'value',
                                style: {
                                    fontWeight: 'bold',
                                },
                            },
                            legend: {
                                color: {
                                    title: false,
                                    position: 'right',
                                    rowPadding: 5,
                                },
                            },
                        }}
                    />
                </Col>
                <Col span={12}>
                    <ProTableOt
                        columns={[
                            {
                                key: '庫存量',
                                title: '庫存量',
                                dataIndex: '庫存量',
                            },
                            {
                                key: 'Action',
                                title: '操作',
                                dataIndex: 'Action',
                            },
                        ]}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={16}>
                    {Array(parseInt(row)).fill(0).map((_, rowItem) => <>
                        <Row>
                            {Array(parseInt(column)).fill(0).map((_, columnItem) => <>
                                <Col>
                                    <Button type={columnItem % 3 === 2 ? 'text' : 'primary'} disabled={columnItem % 3 === 0}>X</Button>
                                </Col>
                            </>)}
                        </Row >
                    </>)}
                </Col>
                <Col span={8}>
                    <ProTableOt
                        columns={[
                            {
                                key: '區域庫存量',
                                title: '區域庫存量',
                                dataIndex: '區域庫存量',
                            },
                            {
                                key: '庫存量',
                                title: '庫存量',
                                dataIndex: '庫存量',
                            },
                            {
                                key: 'Action',
                                title: '操作',
                                dataIndex: 'Action',
                            },
                        ]}
                    />
                </Col>
            </Row>
        </>}
        {modeActiveKey === t('list') && <>
            <PlanRecordForm
                propsForm={propsForm}
                formReloadCount={formReloadCount}
                onFormFinish={onFormFinish}
                keyPrefix={keyPrefix}
            />
        </>}
    </>
}